import 'jquery-mapael/js/maps/world_countries.js';
import 'jquery-mapael';

window.SiteReady(($) => {

  console.log('Init Block: Locations Map');

  let $locationMaps = $('.js-locations_map');

  $locationMaps.each(function(index, el) {
    let $mapBlock = $(el);
    let $mapContainer = $mapBlock.find('.map_container');

    if (typeof LOCATIONS_MAP_DATA !== 'undefined') {
      var mapData = LOCATIONS_MAP_DATA;

      var areaProps = {
        attrs: {
          fill: '#1E489A',
          stroke: '#1E489A',
          'stroke-width': 1,
          animDuration: 0
        },
        attrsHover: {
          fill: '#1E489A'
        }
      };

      var plotProps = {
        attrs: {
          fill: '#009BA0',
          stroke: 'rgba(0, 155, 160, 0.3)',
          'stroke-width': 0,
        },
        attrsHover: {
          fill: '#009BA0',
          stroke: 'rgba(0, 155, 160, 0.3)',
          'stroke-width': 24,
          animDuration: 0
        },
        size: 10,
        eventHandlers: {
          click: function (e, id, mapEl, textEl, plotEl) {
            if ( plotEl.tooltip && plotEl.tooltip.link && plotEl.tooltip.link.url ) {
              window.open(plotEl.tooltip.link.url, 'versar_download');
            }
          }
        }
      };

      $mapContainer.mapael({
        map: {
          name: 'world_countries',
          defaultPlot: plotProps,
          defaultArea: areaProps
        },
        plots: mapData,
      });

    }

  });

});